export default "__VITE_ASSET__BOXX1eJd__"